import { Responsive, WidthProvider } from 'react-grid-layout';
import r from 'render-dom';
import styled from 'styled-components';

import RankInsightSkeletonLayout from '../Widgets/RankInsight/SmallWidget/SkeletonLayout';

const Widget = styled.div`
    background: #fff;
    border-radius: 10px;
    box-shadow: rgb(222, 222, 222) 0px 0px 30px 0px;
    box-sizing: border-box;
    display: flex;
    flex: 1;
    flex-direction: column;
    height: 100%;
    margin-bottom: 40px;
    padding: 18px;
`;

const ResponsiveGrid = WidthProvider(Responsive, { measureBeforeMount: false });

const layout = [
    { h: 1, i: '1', isResizable: false, w: 1, x: 0, y: 0 },
    { h: 1, i: '2', isResizable: false, w: 1, x: 1, y: 0 },
    { h: 1, i: '3', isResizable: false, w: 1, x: 2, y: 0 },
    { h: 1, i: '4', isResizable: false, w: 1, x: 0, y: 1 },
    { h: 1, i: '5', isResizable: false, w: 1, x: 1, y: 1 },
    { h: 1, i: '6', isResizable: false, w: 1, x: 2, y: 1 },
];

export default function SkeletonDashboardGrid() {
    return (
        r.div({ style: { marginTop: 40, position: 'relative' } }, [
            r(ResponsiveGrid, {
                autoSize: true,
                breakpoints: { lg: 800, md: 600, sm: 400, xs: 200 },
                cols: { lg: 3, md: 2, sm: 1, xs: 1 },
                compactType: 'horizontal',
                containerPadding: [0, 0],
                draggableHandle: '.icon-drag-handle',
                isDraggable: true,
                isResizable: false,
                key: 'widget-grid',
                layouts: { lg: layout },
                margin: [20, 20],
                rowHeight: 320,
                style: { position: 'relative' },
                useCSSTransforms: false,
            }, [
                [1, 2, 3, 4, 5].map((key) => (
                    r(Widget, { key }, [
                        r(RankInsightSkeletonLayout),
                    ])
                )),
            ]),
        ])
    );
}
